import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { PullToRefresh, Empty, Toast, Image, Tabs, Popup, Grid, DotLoading, Dialog } from 'antd-mobile'
import { DownOutline, FireFill, CheckOutline, DeleteOutline } from 'antd-mobile-icons'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import API_ROUTES from '../api'
import Icon from '../icon'
import './index.css'
import { useAuth } from '../app/providers/AuthProvider'

const renderRankUI = (rank) => {
    if (rank === 1) return <Image src="https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/no1.png" width={30} height={30} />
    if (rank === 2) return <Image src="https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/no2.png" width={30} height={30} />
    if (rank === 3) return <Image src="https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/no3.png" width={30} height={30} />
    return rank;
}

const ChartRow = React.memo(({ rank, image, name, data, unit, subData, badges, id, index, navigate }) => (
    <div
        className="charts-item"
        // 点击榜单单行进入球员个人页，避免榜单行缺少 navigate 时触发报错。
        onClick={() => id && navigate(`/members/${id}`)}
    >
        <div className={`col-rank col-rank-${rank}`}>{renderRankUI(rank)}</div>
        <div className="col-player">
            <Image
                src={image ? (image + Icon.ImageFooter) : Icon.KEPENG_LOGO}
                className="charts-avatar"
                fit='cover'
            />
            <div className="charts-name">{name}</div>
            {badges}
        </div>
        <div className="col-data">
            <div>
                <span className="data-main">{data}</span>
                {unit && <span className="data-unit">{unit}</span>}
            </div>
            {subData && <span className="data-sub">{subData}</span>}
        </div>
    </div>
));

const MvpRow = React.memo(({ rank, image, name, m1, m2, m3, id, index, navigate }) => (
    <div
        className="mvp-card"
        // MVP 榜也统一跳转到对应球员个人信息页。
        onClick={() => id && navigate(`/members/${id}`)}
    >
        <div className={`col-rank col-rank-${rank}`}>{renderRankUI(rank)}</div>
        <div className="col-player">
            <Image src={image ? (image + Icon.ImageFooter) : Icon.KEPENG_LOGO} className="charts-avatar" />
            <div className="charts-name">{name}</div>
        </div>
        <div className="mvp-medals">
            <div className="mvp-medal-item"><span className="mvp-icon">🥇</span><span className="mvp-count">x{m1 || 0}</span></div>
            <div className="mvp-medal-item"><span className="mvp-icon">🥈</span><span className="mvp-count">x{m2 || 0}</span></div>
            <div className="mvp-medal-item"><span className="mvp-icon">🥉</span><span className="mvp-count">x{m3 || 0}</span></div>
        </div>
    </div>
));

export default function Charts() {
    const navigate = useNavigate()
    const { memberInfo, isAuthenticated } = useAuth()

    // Popup States
    const [yearsAction, setYearsAction] = useState([])
    const [yearsPopupVisible, setYearsPopupVisible] = useState(false)
    const [yearsButton, setYearsButton] = useState()

    const [gameTypeAction, setGameTypeAction] = useState([])
    const [gameTypePopupVisible, setGameTypePopupVisible] = useState(false)
    const [gameTypeButton, setGameTypeButton] = useState({ text: '内讧赛', value: 3 })

    const [activeTab, setActiveTab] = useState('7')
    const [tabPopupVisible, setTabPopupVisible] = useState(false)
    const [playTimeRankMode, setPlayTimeRankMode] = useState(1)

    const [groups, setGroups] = useState([])
    const [refreshing, setRefreshing] = useState(false)

    // Configuration
    const chartTabs = useMemo(() => [
        { key: '7', title: '出勤榜' },
        { key: '1', title: '积分榜' },
        { key: '2', title: '进球榜' },
        { key: '3', title: '助攻榜' },
        { key: '6', title: '乌龙榜' },
        { key: '10', title: '吃牌榜' },
        { key: '11', title: 'MVP榜' },
        { key: '12', title: '裁判榜' },
        { key: '4', title: '防守榜' },
        { key: '19', title: '零封榜' },
        { key: '5', title: '进攻榜' },
        { key: '20', title: '饥渴度榜' },
        { key: '13', title: '上场时间榜' },
        { key: '14', title: '历史出勤榜' },
        { key: '15', title: '最长连胜榜' },
        { key: '16', title: '最长不败榜' },
        { key: '17', title: '最长连败榜' },
        { key: '18', title: '最长不胜榜' },
        { key: '8', title: '鸽子榜' },
        { key: '9', title: '懒人榜' },
    ], []);

    const activeTabTitle = useMemo(() => {
        return chartTabs.find(t => t.key === activeTab)?.title || '榜单';
    }, [activeTab, chartTabs]);

    const halfAttendanceNotice = useMemo(() => {
        if (!['4', '5', '20'].includes(activeTab)) return null;
        return {
            '4': '防守榜仅统计参与场次超过赛季比赛数 1/2 的常驻队员',
            '5': '进攻榜仅统计参与场次超过赛季比赛数 1/2 的常驻队员',
            '20': '饥渴度榜仅统计参与场次超过赛季比赛数 1/2 的常驻队员',
        }[activeTab];
    }, [activeTab]);

    const getSeasonListInfo = useCallback(() => {
        Toast.show({ icon: 'loading', duration: 0 })
        axios.get(API_ROUTES.season_list)
            .then(res => {
                const result = res.data.data
                if (result.length > 0) {
                    const actions = result.map(item => ({
                        text: item.seasonName,
                        key: item.id,
                        fullItem: item
                    }));
                    setYearsAction(actions);
                    const first = result.find(item => item.isFirst === 1) || result[0];
                    setYearsButton({ text: first.seasonName, value: first.id });
                }
            })
            .catch(() => Toast.show({ icon: 'fail', content: "服务错误" }))
            .finally(() => Toast.clear());
    }, [])

    const getList = useCallback((key, year, type, gameType) => {
        if (!year) return;
        if (key === '12' && !type) type = 1;

        // Clear old list to prevent flickering
        setGroups([]);
        setRefreshing(true);

        axios.get(API_ROUTES.game_charts, {
            params: { key, year, type, gameType: gameType || 3 }
        })
            .then(res => setGroups(res.data.data || []))
            .catch(err => console.error(err))
            .finally(() => setRefreshing(false));
    }, [])

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/login')
            return
        }
        setGameTypeAction([
            { text: '内讧赛', key: 3 },
            { text: '友谊赛', key: 1 },
            { text: '正式赛', key: 2 },
            { text: '活动赛', key: 4 },
            { text: '全部比赛类型', key: 5 }
        ])
        getSeasonListInfo()
    }, [getSeasonListInfo, isAuthenticated, navigate])

    useEffect(() => {
        if (yearsButton?.value) {
            const rankType = activeTab === '13' ? playTimeRankMode : null;
            getList(activeTab, yearsButton.value, rankType, gameTypeButton.value);
        }
    }, [activeTab, gameTypeButton, getList, playTimeRankMode, yearsButton]);

    const handleClearCache = () => {
        Dialog.confirm({
            content: '确定要刷新排行榜缓存吗？',
            onConfirm: async () => {
                try {
                    Toast.show({ icon: 'loading', duration: 0 })
                    const res = await axios.get(API_ROUTES.clear_cache);
                    if (res.data.code === 200) {
                        Toast.show({ icon: 'success', content: '缓存清理成功' });
                        const rankType = activeTab === '13' ? playTimeRankMode : (activeTab === '12' ? 1 : null);
                        getList(activeTab, yearsButton?.value, rankType, gameTypeButton.value);
                    } else {
                        Toast.show({ icon: 'fail', content: res.data.msg || '清理失败' });
                    }
                } catch (e) {
                    Toast.show({ icon: 'fail', content: '请求失败' });
                } finally {
                    Toast.clear()
                }
            }
        })
    }

    const headers = useMemo(() => {
        const commonRank = "排名";
        const commonPlayer = "球员";
        switch (activeTab) {
            case '7': return [commonRank, commonPlayer, "总出勤 | 明细"];
            case '1': return [commonRank, commonPlayer, "积分 | 胜平负"];
            case '2': return [commonRank, commonPlayer, "进球(点) | 场次"];
            case '3': return [commonRank, commonPlayer, "助攻 | 场均"];
            case '4': return [commonRank, commonPlayer, "失球数 | 场均(球)"];
            case '5': return [commonRank, commonPlayer, "造球数 | 场均(球)"];
            case '6': return [commonRank, commonPlayer, "乌龙 | 场次"];
            case '8': return [commonRank, commonPlayer, "鸽子 | 总场次"];
            case '9': return [commonRank, commonPlayer, "懒人 | 总场次"];
            case '10': return [commonRank, commonPlayer, "红/黄牌 | 场次"];
            case '11': return [commonRank, commonPlayer, "获选次数"]; // MVP
            case '12': return ["排名", "裁判", "执裁场次"];
            case '13': return [commonRank, commonPlayer, playTimeRankMode === 1 ? "场均 | 总时长" : "总时长 | 场均"];
            case '14': return [commonRank, commonPlayer, "历史总场次"];
            case '15': case '16': case '17': case '18': return [commonRank, commonPlayer, "连续场次"];
            case '19': return [commonRank, commonPlayer, "全场 | 单节"];
            case '20': return [commonRank, commonPlayer, "平均报名位次"];
            default: return [commonRank, commonPlayer, "数据"];
        }
    }, [activeTab, playTimeRankMode]);

    const renderList = () => {
        if (refreshing) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', padding: '40px 0', alignItems: 'center', gap: '15px' }}>
                    <DotLoading color='primary' />
                    <span style={{ fontSize: '13px', color: '#86909C', fontWeight: 700 }}>正在加载排行数据...</span>
                </div>
            );
        }

        if (!groups || groups.length === 0) return <Empty description='暂无数据' />;

        const streakBadges = (item) => item.streakStatus === 1 ? (
            <FireFill color='#F53F3F' style={{ marginLeft: 6, fontSize: 18 }} />
        ) : null;

        const streakTabs = ['15', '16', '17', '18'];
        const displayGroups = streakTabs.includes(activeTab) ? groups.filter(item => item.score > 2) : groups;

        return displayGroups.map((item, index) => {
            const rank = item.rank || (index + 1);
            if (activeTab === '11') {
                return <MvpRow key={item.id || index} rank={rank} image={item.image} name={item.name} m1={item.mvpOne} m2={item.mvpTwo} m3={item.mvpThree} id={item.userId} index={index} navigate={navigate} />
            }

            let main = item.score, unit = '', sub = '';
            switch (activeTab) {
                case '1':
                    const winRate = item.attendanceCount > 0 ? ((item.successCount / item.attendanceCount) * 100).toFixed(0) + '%' : '-';
                    main = item.score; unit = '分'; sub = `${item.successCount}胜${item.drawCount}平${item.failCount}负  胜率${winRate}`;
                    break;
                case '2': main = item.penaltyGoals && item.penaltyGoals !== '0' ? `${item.score}(${item.penaltyGoals})` : item.score; unit = '球'; sub = `场均 ${item.avgScore} ${item.attendanceCount}场`; break;
                case '3': main = item.score; unit = '次'; sub = `场均 ${item.avgScore}`; break;
                case '4': main = item.score; unit = '球'; sub = `场均失球 ${item.avgScore}次`; break;
                case '5': main = item.score; unit = '球'; sub = `场均造球 ${item.avgScore}次`; break;
                case '6': main = item.score; unit = '个'; sub = `${item.attendanceCount}场`; break;
                case '8': main = item.score; unit = '次'; sub = `${item.totalCount}场`; break;
                case '9': main = item.score; unit = '次'; sub = `${item.totalCount}场`; break;
                case '10': main = `${item.cardCount}/${item.score}`; unit = '红/黄'; sub = `${item.attendanceCount}场`; break;
                case '12': main = item.score; unit = '场'; break;
                case '13':
                    // 上场时间榜支持按场均或总时长排序，主副数据跟随当前模式切换。
                    if (playTimeRankMode === 1) {
                        main = item.avgScore; unit = '分'; sub = `总时长 ${item.score}分`;
                    } else {
                        main = item.score; unit = '分'; sub = `场均 ${item.avgScore}分`;
                    }
                    break;
                case '14': main = item.historyCount; unit = '场'; sub = '历史总计'; break;
                case '15': case '16': case '17': case '18': main = item.score; unit = '场'; break;
                case '19': main = item.avgScore; unit = '场'; sub = `单节 ${item.score}次`; break;
                case '20': main = item.score; unit = '名'; sub = `平均位次`; break;
                case '7':
                    // 出勤率仅按比赛出勤计算；聚餐次数只作为明细展示，不参与百分比。
                    const totalAttendance = Number(item.totalAttendanceCount ?? item.attendanceCount ?? 0);
                    const totalEventCount = Number(item.totalCount || 0);
                    const gameAttendance = Number(item.gameAttendanceCount || 0);
                    const dinnerAttendance = Number(item.dinnerAttendanceCount || 0);
                    const totalGameCount = Number(item.totalGameCount || 0);
                    const totalDinnerCount = Number(item.totalDinnerCount || 0);
                    main = totalGameCount > 0 ? `${((gameAttendance / totalGameCount) * 100).toFixed(0)}%` : '0%';
                    sub = (
                        <span className="attendance-detail">
                            <span>总 {totalAttendance}/{totalEventCount}次</span>
                            <span className="attendance-split">
                                <span>比赛 {gameAttendance}/{totalGameCount}</span>
                                <span>聚餐 {dinnerAttendance}/{totalDinnerCount}</span>
                            </span>
                        </span>
                    );
                    break;
                default: main = item.score;
            }

            return (
                <ChartRow
                    key={item.id || index}
                    id={item.userId || item.id}
                    rank={rank}
                    image={item.image}
                    name={item.name}
                    data={main}
                    unit={unit}
                    subData={sub}
                    badges={streakBadges(item)}
                    index={index}
                    navigate={navigate}
                />
            )
        });
    }

    return (
        <div className="charts-container">


            <div className="charts-header">
                <div className="charts-top-bar">
                    <div className="charts-head-btn" onClick={() => setYearsPopupVisible(true)}>
                        <span>{yearsButton?.text}</span>
                        <DownOutline fontSize={10} />
                    </div>
                    <div className="charts-head-btn charts-title-trigger" onClick={() => setTabPopupVisible(true)}>
                        <span>{activeTabTitle}</span>
                        <DownOutline fontSize={10} />
                    </div>
                    <div className="charts-head-btn" onClick={() => setGameTypePopupVisible(true)}>
                        <span>{gameTypeButton?.text}</span>
                        <DownOutline fontSize={10} />
                    </div>
                    {memberInfo?.admin === 1 && (
                        <div className="charts-head-btn charts-clear-btn" onClick={handleClearCache}>
                            <DeleteOutline fontSize={14} />
                            <span>缓存</span>
                        </div>
                    )}
                </div>

                <div className="charts-record-notice">KEPENG DATA CENTER SINCE 2017</div>

                {activeTab === '13' && (
                    <div className="charts-mode-row">
                        <button
                            className={`charts-mode-btn ${playTimeRankMode === 1 ? 'active' : ''}`}
                            onClick={() => setPlayTimeRankMode(1)}
                        >
                            场均排名
                        </button>
                        <button
                            className={`charts-mode-btn ${playTimeRankMode === 2 ? 'active' : ''}`}
                            onClick={() => setPlayTimeRankMode(2)}
                        >
                            总时长排名
                        </button>
                    </div>
                )}

                {halfAttendanceNotice && (
                    <div className="charts-scope-notice">
                        <span className="charts-scope-icon">i</span>
                        <span>{halfAttendanceNotice}</span>
                    </div>
                )}

                <div className="charts-column-header">
                    <div style={{ width: 40, textAlign: 'center' }}>{headers[0]}</div>
                    <div style={{ flex: 1, paddingLeft: 20 }}>{headers[1]}</div>
                    <div style={{ width: 120, textAlign: 'right' }}>{headers[2]}</div>
                </div>
            </div>

            {activeTab === '12' && (
                <Tabs className="charts-sub-tabs" activeLineMode='fixed' onChange={key => getList('12', yearsButton?.value, key, gameTypeButton.value)}>
                    <Tabs.Tab title='主裁' key='1' />
                    <Tabs.Tab title='边裁' key='2' />
                    <Tabs.Tab title='VAR' key='3' />
                    <Tabs.Tab title='观众' key='4' />
                </Tabs>
            )}

            <PullToRefresh refreshing={refreshing} onRefresh={async () => getList(activeTab, yearsButton?.value, activeTab === '12' ? 1 : null, gameTypeButton.value)}>
                <div className="charts-list" style={{ minHeight: '600px' }}>
                    {renderList()}
                </div>
            </PullToRefresh>

            {/* POPUPS */}
            <Popup bodyClassName="charts-popup" visible={tabPopupVisible} onMaskClick={() => setTabPopupVisible(false)}>
                <div className="charts-popup-content">
                    <div className="charts-popup-title">选择赛季排行榜单</div>
                    <Grid columns={3} gap={10}>
                        {chartTabs.map(tab => (
                            <Grid.Item key={tab.key} onClick={() => { setActiveTab(tab.key); setTabPopupVisible(false); }}>
                                <div className={`charts-grid-item ${activeTab === tab.key ? 'active' : ''}`}>{tab.title}</div>
                            </Grid.Item>
                        ))}
                    </Grid>
                </div>
            </Popup>

            <Popup bodyClassName="charts-popup" visible={yearsPopupVisible} onMaskClick={() => setYearsPopupVisible(false)}>
                <div className="charts-popup-content">
                    <div className="charts-popup-title">切换赛季数据周期</div>
                    <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                        {yearsAction.map(item => (
                            <div
                                key={item.key}
                                className={`charts-popup-list-item ${yearsButton?.value === item.key ? 'active' : ''}`}
                                onClick={() => {
                                    setYearsPopupVisible(false);
                                    setYearsButton({ text: item.text, value: item.key });
                                }}
                            >
                                {item.text}
                                {yearsButton?.value === item.key && <CheckOutline fontSize={16} />}
                            </div>
                        ))}
                    </div>
                </div>
            </Popup>

            <Popup bodyClassName="charts-popup" visible={gameTypePopupVisible} onMaskClick={() => setGameTypePopupVisible(false)}>
                <div className="charts-popup-content">
                    <div className="charts-popup-title">选择比赛类型</div>
                    {gameTypeAction.map(item => (
                        <div
                            key={item.key}
                            className={`charts-popup-list-item ${gameTypeButton?.value === item.key ? 'active' : ''}`}
                            onClick={() => {
                                setGameTypePopupVisible(false);
                                setGameTypeButton({ text: item.text, value: item.key });
                            }}
                        >
                            {item.text}
                            {gameTypeButton?.value === item.key && <CheckOutline fontSize={16} />}
                        </div>
                    ))}
                </div>
            </Popup>
        </div>
    )
}
